/**
 * @deprecated
 */
export function formatPhoneNumber(phoneNumber?: string | null | undefined) {
  if (!phoneNumber) return null;

  return phoneNumber;
}
